module.exports = __webpack_public_path__ + "static/page-bg-black-4906e3cf0b4e3eec784a5305b4eb120f.svg";